import React, { useState, useEffect, useRef } from 'react';
import './MathModal.css';

function MathModal({ problem, onSubmit, onClose }) {
  const [answer, setAnswer] = useState('');
  const [isWrong, setIsWrong] = useState(false);
  const inputRef = useRef(null);

  // Reset state when problem changes
  useEffect(() => {
    setAnswer('');
    setIsWrong(false);
    // Focus input when modal opens
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [problem.cell]);

  // Handle incorrect answer - show error and let user retry
  // Depend on wrongAttempts to re-trigger shake on each wrong answer
  useEffect(() => {
    if (problem?.incorrect) {
      setIsWrong(true);
      setAnswer('');
      // Focus input for retry
      if (inputRef.current) {
        inputRef.current.focus();
      }
      // Reset shake animation by briefly removing and re-adding
      const modal = inputRef.current?.closest('.modal-content');
      if (modal) {
        modal.classList.remove('shake');
        // Force reflow to restart animation
        void modal.offsetWidth;
        modal.classList.add('shake');
      }
    }
  }, [problem?.wrongAttempts]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (answer.trim()) {
      setIsWrong(false);
      onSubmit(answer);
    }
  };

  return (
    <div className="modal-overlay">
      <div className={`modal-content ${isWrong ? 'shake' : ''}`}>
        <button className="close-button" onClick={onClose}>×</button>

        <h2>Solve to Attack Cell {problem.cell}</h2>

        <div className="problem">
          {problem.problem}
        </div>

        {isWrong && (
          <div className="wrong-answer-message">
            Try again!
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <input
            ref={inputRef}
            type="number"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            placeholder="Your answer"
            autoFocus
            className={`answer-input ${isWrong ? 'input-error' : ''}`}
          />

          <div className="button-group">
            <button type="submit" className="btn-primary">
              Submit
            </button>
            <button type="button" onClick={onClose} className="btn-secondary">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default MathModal;
